import { Reducer } from 'redux';
import { PageState, PageActionTypes } from './types';

// Type-safe initialState!
export const initialState: PageState = {
  data: {
    grid: { type: 'one_cloumn', header: { class: 'default' }, components: {} },
    forms: [],
  },
  sessionData: {},
  errors: [],
  loading: false,
  previewFile: undefined,
  submitingButtonId: '',
};

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<PageState> = (state = initialState, action) => {
  switch (action.type) {
    case PageActionTypes.PAGE_REQUEST: {
      return { ...state, loading: true, errors: [] };
    }
    case PageActionTypes.PAGE_SUCCESS: {
      return {
        ...state,
        loading: false,
        previewFile: undefined,
        errors: [],
        data: { ...action.payload.data },
        sessionData: { ...action.payload.sessionData },
      };
    }
    case PageActionTypes.PAGE_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    case PageActionTypes.CLEAR_FORMS: {
      return { ...state, data: { ...state.data, forms: [] } };
    }
    case PageActionTypes.UPDATE_ITEM_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: { ...state.data, ...action.payload },
      };
    }
    case PageActionTypes.SET_SUBMIT_BUTTON_ID: {
      return {
        ...state,
        submitingButtonId: action.payload.buttonId,
        errors: [],
      };
    }
    case PageActionTypes.PREVIEW_FILE: {
      return { ...state, previewFile: action.payload };
    }
    case PageActionTypes.UNSET_SUBMIT_BUTTON_ID: {
      return { ...state, submitingButtonId: '' };
    }
    default: {
      return state;
    }
  }
};

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as pageReducer };
